
import ChatbotSelectPatient from "./ChatbotSelectPatient";

export default ChatbotSelectPatient;